import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./Process.css";

const Process = () => {
  // Refs for each section for parallax effect
  const headerRef = useRef(null);
  const phase1Ref = useRef(null);
  const phase2Ref = useRef(null);
  const phase3Ref = useRef(null);

  // Parallax effect for header
  const { scrollYProgress: scrollYHeader } = useScroll({
    target: headerRef,
    offset: ["start end", "end start"],
  });
  const headerY = useTransform(scrollYHeader, [0, 1], [0, -100]);

  // Parallax effect for Phase 1
  const { scrollYProgress: scrollYPhase1 } = useScroll({
    target: phase1Ref,
    offset: ["start end", "end start"],
  });
  const phase1Y = useTransform(scrollYPhase1, [0, 1], [0, -100]);

  // Parallax effect for Phase 2
  const { scrollYProgress: scrollYPhase2 } = useScroll({
    target: phase2Ref,
    offset: ["start end", "end start"],
  });
  const phase2Y = useTransform(scrollYPhase2, [0, 1], [0, -100]);

  // Parallax effect for Phase 3
  const { scrollYProgress: scrollYPhase3 } = useScroll({
    target: phase3Ref,
    offset: ["start end", "end start"],
  });
  const phase3Y = useTransform(scrollYPhase3, [0, 1], [0, -100]);

  return (
    <main id="main-content">
      {/* Header Section */}
      <section ref={headerRef} className="process-header-section">
        <motion.div
          className="process-header-background"
          style={{ y: headerY }}
        ></motion.div>
        <div className="process-header-content">
          <h1 className="process-title">
            The <span className="yellow-text">Kynetic</span> Reaction Loop.
          </h1>
          <p className="process-subtitle">
            How we consistently deliver results.
          </p>
          <button
            className="scroll-down-button"
            onClick={() => {
              document
                .getElementById("phase1")
                .scrollIntoView({ behavior: "smooth" });
            }}
            aria-label="Scroll down"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M12 5L12 19M12 19L19 12M12 19L5 12"
                stroke="#FFD700"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </section>

      {/* Phase 1 - Discovery */}
      <section
        id="phase1"
        ref={phase1Ref}
        className="process-section  process-section-1"
      >
        <motion.div
          className="process-background"
          style={{ y: phase1Y }}
        ></motion.div>
        <div className="process-container">
          <div className="process-content">
            <p className="phase-number yellow-text" aria-hidden="true">
              Phase 1 →
            </p>
            <h2 className="phase-title">Discovery (Potential Energy)</h2>
            <p className="phase-description">
              We dive deep into your data, your competitors, and your audience.
              We define the KPIs that matter and set the baseline.
            </p>
          </div>
        </div>
      </section>

      {/* Phase 2 - Ignition */}
      <section
        ref={phase2Ref}
        className="process-section reverse process-section-2"
      >
        <motion.div
          className="process-background"
          style={{ y: phase2Y }}
        ></motion.div>
        <div className="process-container">
          <div className="process-content">
            <p className="phase-number yellow-text" aria-hidden="true">
              Phase 2 →
            </p>
            <h2 className="phase-title">Ignition (Activation)</h2>
            <p className="phase-description">
              We launch the strategy. Whether it's a rebrand, a new website, or
              a multi-channel ad campaign, we go live with precision.
            </p>
          </div>
        </div>
      </section>

      {/* Phase 3 - Momentum */}
      <section ref={phase3Ref} className="process-section process-section-3">
        <motion.div
          className="process-background"
          style={{ y: phase3Y }}
        ></motion.div>
        <div className="process-container">
          <div className="process-content">
            <p className="phase-number yellow-text" aria-hidden="true">
              Phase 3 →
            </p>
            <h2 className="phase-title">Momentum (Optimization)</h2>
            <p className="phase-description">
              We don't "set and forget." We analyze real-time data to cut wasted
              spend and double down on what's working. This is where good
              campaigns become great ones.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Process;
